module.exports = __webpack_public_path__ + "img/036-overcome.b250832d.svg";